import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap";
import CardHeader from "react-bootstrap/CardHeader";
import BgDashboard from "./images/bg-dashboard.png";
import "./styles/dashboard.css";
import { useAPI } from "../../hooks/useAPI";
import PairingsChart from "./components/PairingsChart";
import Loader from "../../components/messages/Loader";
import BusinessSelect from "../../components/form/BusinessSelect";
import { useAuth } from "../../hooks/useAuth";
import moment from "moment";
import CustomSelect from "../../components/form/CustomSelect";
import { PersonModel } from "../../models/PersonModel";
import { OptionType } from "../../types/CommonType";
import NumberFormat from "react-number-format";
import { LANG_COMMON_PAYMENT, LANG_COMMON_SUBSCRIPTION } from "../../lang";
import { useIntl } from "react-intl";
import PaymentAddModal from "./components/PaymentAddModal";
import Confirm from "../../components/messages/Confirm";
import PlanAddModal from "./components/PlanAddModal";

const DashboardSubscriptionPage = () => {
    const { api } = useAPI();
    const [stats, setStats] = useState<undefined | any>(undefined);
    const [plans, setPlans] = useState<undefined | any>([]);
    const [fromDate, setFromDate] = useState<string>("");
    const [toDate, setToDate] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [searchFromBusiness, setSearchFromBusiness] = useState<number | undefined>(undefined);
    const [status, setStatus] = useState<string>("");
    const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);
    const [showPlanModal, setShowPlanModal] = useState<boolean>(false);
    const [planToEdit, setPlanToEdit] = useState<any>(undefined);
    const [showCancelPaymentModal, setShowCancelPaymentModal] = useState<boolean>(false);
    const [paymentToCancel, setPaymentToCancel] = useState<number | undefined>(undefined);
    const { hasAbility } = useAuth();
    const intl = useIntl();

    const loadStats = (options: any) => {
        setLoading(true);
        api().get(`/api/stats/subscriptions?${new URLSearchParams({ ...options, cache: (new Date()).getTime(), dateFrom: fromDate, dateTo: toDate, status: status }).toString()}`)
            .then((resp) => {
                setStats(resp.data);
                setLoading(false);
            });
    }

    const loadPlans = () => {
        api().get(`/api/plan/master`)
            .then((resp) => {
                setPlans(resp.data);
            });
    }

    useEffect(() => {
        loadStats({});
        loadPlans();
    }, []);

    return (
        <>
            {loading && (<Loader fullscreen={true} />)}
            {!loading && stats !== undefined && (
                <div className="bg-pattern" style={{ 'paddingBottom': '2rem' }}>
                    <Container>
                        {showPaymentModal && (
                            <PaymentAddModal
                                show={showPaymentModal}
                                onHide={() => setShowPaymentModal(false)}
                                onSave={() => {
                                    setShowPaymentModal(false);
                                    loadPlans();
                                }}
                            />
                        )}
                        {showPlanModal && (
                            <PlanAddModal
                                show={showPlanModal}
                                onHide={() => setShowPlanModal(false)}
                                onSave={() => {
                                    setShowPlanModal(false);
                                    loadPlans();
                                }}
                                plan={planToEdit}
                            />
                        )}
                        {showCancelPaymentModal && (
                            <Confirm
                                message="Tem certeza que deseja cancelar este pagamento?"
                                show={showCancelPaymentModal}
                                onHide={() => setShowCancelPaymentModal(false)}
                                onConfirm={() => {
                                    setShowCancelPaymentModal(false);
                                    setLoading(true);
                                    api().del(`/api/payments/${paymentToCancel}/cancel`)
                                        .then((resp) => {
                                            loadStats({});
                                        })
                                        .catch((e) => {
                                            alert(e.response.data.message);
                                            setLoading(false);
                                            loadStats({});
                                        });
                                }}
                            />
                        )}
                        <Row>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Assinaturas</Breadcrumb.Item>
                            </Breadcrumb>
                        </Row>
                        <Row>
                            <Col lg={{ offset: 0, span: 8 }}>
                                <Card>
                                    <CardHeader className={'d-flex'} style={{ "padding": "4px 1rem" }}>
                                        <div className="card-title h5 w-100">
                                            <div className="row">
                                                <div className="col-md-6" style={{ "paddingTop": "3px" }}>
                                                    {intl.formatMessage(LANG_COMMON_PAYMENT)}
                                                </div>
                                                <div className="text-end col-md-6">
                                                    <a
                                                        href="#"
                                                        className="btn-plus"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setShowPaymentModal(true)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <div className="card-body" style={{ 'padding': '0' }}>
                                        <Table striped>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>CLÍNICA</th>
                                                    <th>Plano</th>
                                                    <th>Valor</th>
                                                    <th>Parcelas</th>
                                                    <th>Status</th>
                                                    <th>Período</th>
                                                    <th>Opções</th>
                                                    {/*<th>Nota Fiscal</th>*/}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <>
                                                    {stats?.payments.length === 0 && (
                                                        <tr>
                                                            <td colSpan={6} className={"text-center"}>
                                                                Nenhum resultado encontrado.
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {stats?.payments.map((item: any) => (
                                                        <tr key={item.id}>
                                                            <td>{item.id}</td>
                                                            <td>{item.subscription.business.name}</td>
                                                            <td>{item.subscription.plan.name}</td>
                                                            <td><NumberFormat
                                                                value={parseFloat(item.subscription.payment_option?.total)}
                                                                displayType={'text'}
                                                                thousandSeparator={"."}
                                                                decimalSeparator={","}
                                                                prefix={'R$'} /></td>
                                                            <td>{item.subscription.payment_option?.installments}</td>
                                                            <td>
                                                                <b>
                                                                    {item.status === "PEN" && (
                                                                        <span className="text-warning">PENDENTE</span>
                                                                    )}
                                                                    {item.status === "PAI" && (
                                                                        <span className="text-success">PAGO</span>
                                                                    )}
                                                                    {item.status === "CAN" && (
                                                                        <span className="text-danger">CANCELADO</span>
                                                                    )}
                                                                </b>
                                                            </td>
                                                            <td>{moment(item.start_at).format("DD/MM/YYYY")} - {moment(item.end_at).format("DD/MM/YYYY")}</td>
                                                            <td>
                                                                <a
                                                                    title="Cancelar pagamento"
                                                                    href=""
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowCancelPaymentModal(true);
                                                                        setPaymentToCancel(item.id);
                                                                    }}
                                                                >
                                                                    <i className="bi bi-x-circle-fill icon" style={{ "color": "#dc3545", "fontSize": "18px" }} />
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card>

                                <Card className="mt-4">
                                    <CardHeader className={'d-flex'} style={{ "padding": "4px 1rem" }}>
                                        <div className="card-title h5 w-100">
                                            <div className="row">
                                                <div className="col-md-6" style={{ "paddingTop": "3px" }}>
                                                    PLANOS
                                                </div>
                                                <div className="text-end col-md-6">
                                                    <a
                                                        href="#"
                                                        className="btn-plus"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setShowPlanModal(true)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <div className="card-body" style={{ 'padding': '0' }}>
                                        <Table striped>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Nome</th>
                                                    <th>Recorrência</th>
                                                    <th>Máx. Pessoas</th>
                                                    <th>Máx. Usuários</th>
                                                    <th>Opções de Pgto.</th>
                                                    <th>Opções</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <>
                                                    {plans.length === 0 && (
                                                        <tr>
                                                            <td colSpan={6} className={"text-center"}>
                                                                Nenhum resultado encontrado.
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {plans.map((item: any) => (
                                                        <tr key={item.id}>
                                                            <td>{item.id}</td>
                                                            <td>{item.name}</td>
                                                            <td>{item.recurrency === "M" ? "Mensal" : "Anual"}</td>
                                                            <td>{item.max_persons}</td>
                                                            <td>{item.max_users}</td>
                                                            <td>
                                                                {item.payment_options.map((option: any) => (
                                                                    <div key={option.id}>{option.recurrency === "M" ? "Mensal" : "Anual"} - {option.installments}X de {option.installment_price}
                                                                    <a 
                                                                        href=""
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setPlanToEdit({
                                                                                id: option.id,
                                                                                name: item.name,
                                                                                price: option.installment_price,
                                                                                description: item.description,
                                                                                recurrency: option.recurrency,
                                                                                max_persons: item.max_persons,
                                                                                max_users: item.max_users,
                                                                            });
                                                                            setShowPlanModal(true);
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-pencil-fill"></i>
                                                                    </a>
                                                                    </div>
                                                                ))}
                                                            </td>
                                                            <td>
                                                                <a
                                                                    title="Cancelar plano"
                                                                    href=""
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowCancelPaymentModal(true);
                                                                        setPaymentToCancel(item.id);
                                                                    }}
                                                                >
                                                                    <i className="bi bi-x-circle-fill icon" style={{ "color": "#dc3545", "fontSize": "18px" }} />
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={{ span: 4 }}>
                                <Card>
                                    <CardHeader>
                                        <Card.Title>OPÇÕES</Card.Title>
                                    </CardHeader>
                                    <Card.Body>
                                        <Form onSubmit={(e) => {
                                            e.preventDefault();
                                            loadStats({});
                                        }}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>De:</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            onChange={(e) => setFromDate(e.target.value)}
                                                            value={fromDate}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Até:</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            disabled={fromDate === ""}
                                                            min={fromDate}
                                                            onChange={(e) => setToDate(e.target.value)}
                                                            value={toDate}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-12">
                                                    <Form.Group className="mb-3" controlId="name">
                                                        <Form.Label>Status</Form.Label>
                                                        <CustomSelect
                                                            name="status"
                                                            options={[
                                                                { label: "Pago", value: "PAI" },
                                                                { label: "Pendente", value: "PEN" },
                                                                { label: "Cancelado", value: "CAN" },
                                                            ]}
                                                            onChange={(option: OptionType) => {
                                                                if (option !== null) {
                                                                    setStatus(option.value);
                                                                } else {
                                                                    setStatus("");
                                                                }
                                                            }}
                                                            value={status}
                                                            placeholder={"Selecione..."}
                                                            isMulti={false}
                                                            isSearchable={false}
                                                            isClearable={true}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-12">
                                                    {hasAbility('BUSINESS_LIST') && (
                                                        <>
                                                            <label htmlFor="exampleInputEmail1" className="form-label">Clínica:</label>
                                                            <BusinessSelect
                                                                businessId={searchFromBusiness}
                                                                onChange={(business_id) => {
                                                                    setSearchFromBusiness(business_id);
                                                                    loadStats({ business_id: (business_id === undefined) ? "" : business_id });
                                                                }}
                                                            />

                                                            <br />
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-grid gap-2">
                                                <div className="row">
                                                    <div className="col-md-8 offset-2">
                                                        <Button variant="primary" size={'lg'}
                                                            type="submit" className="btn-custom btn-custom-small bg-custom-gradient w-100">Buscar</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                                <div className="my-4">
                                    <Card>
                                        <CardHeader>
                                            <Card.Title>DADOS</Card.Title>
                                        </CardHeader>
                                        <Card.Body>
                                            <div className="row dashboard-stats">
                                                <div className="col-md-6 stats-donors">
                                                    <h4>CLÍNICAS</h4>
                                                    <h6>{stats.total_business}</h6>
                                                </div>
                                                <div className="col-md-6 stats-receivers">
                                                    <h4>ASSINANTES</h4>
                                                    <h6>{stats.total_subscriptions}</h6>
                                                </div>
                                                <div className="col-md-6 stats-pairings">
                                                    <h4>ASSINANTES ATIVOS</h4>
                                                    <h6>{stats.total_active_subscriptions}</h6>
                                                </div>
                                                <div className="col-md-6 stats-born-alive">
                                                    <h4>ASSINANTES EM ATRASO</h4>
                                                    <h6>{stats.total_due_subscriptions}</h6>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}
        </>
    );
}

export default DashboardSubscriptionPage;